import React from 'react';
import { path as d3Path } from 'd3-path';

const roundedBarPath: (
  height: number,
  width: number,
  radius: number,
) => string = (height, width, radius = 0) => {
  if (!height || !width) {
    return '';
  }
  radius = Math.max(Math.min(radius, Math.abs(height) - 1), 0);
  const edgeHeight = height > 0 ? height - radius : height + radius;
  const edgeWidth = width - radius * 2;

  const path = d3Path();
  path.moveTo(0, 0);
  path.lineTo(0, edgeHeight);
  path.arc(radius, edgeHeight, radius, Math.PI, Math.PI * 1.5);
  path.lineTo(edgeWidth + radius, height);
  path.arc(edgeWidth + radius, edgeHeight, radius, Math.PI * 1.5, Math.PI * 2);
  path.lineTo(width, 0);
  path.closePath();

  return path.toString();
};

export interface Props {
  children?: any;
  className?: string;
  height?: number;
  radius?: number;
  width?: number;
}

class RoundedBar extends React.Component<Props, any> {
  static defaultProps: Props = {
    height: 10,
    radius: 5,
    width: 10,
  };

  public render() {
    const { height, width, radius, className } = this.props;

    return (
      <g className={className}>
        <path d={roundedBarPath(height, width, radius)}>
          {this.props.children}
        </path>
      </g>
    );
  }
}

export default RoundedBar;
